module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/head-3c0fbe6d130c71057878a28d878441dc.png";